import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import useApp from "../../store/contexts/AppContext";

function AdminRoomDeletion({ roomName, roomId, handleAdminDeletionClose }) {
  const {
    deleteChatRoonApiCall
  } = useApp();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
        p: 2,
        backgroundColor: "white",
        border: "1px solid #ccc",
      }}
    >
      <div>
        Are you sure you want to delete room: <b>{roomName}</b>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          color="success"
          onClick={() => deleteChatRoonApiCall(roomId)}
        >
          Confirm
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleAdminDeletionClose}
        >
          Cancel
        </Button>
      </div>
    </Box>
  );
}

export default AdminRoomDeletion;
